var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ShopAfterSalesService from "../../../api/ShopAfterSalesService";
var CancelDialog = (function (_super) {
    __extends(CancelDialog, _super);
    function CancelDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            type: 3,
            remark: ''
        };
        return _this;
    }
    CancelDialog.prototype.created = function () {
        this.service = ShopAfterSalesService.getInstance();
    };
    CancelDialog.prototype.close = function () {
        this.$closeDialog();
    };
    CancelDialog.prototype.checkSave = function () {
        var _this = this;
        if (!this.formData.remark) {
            this.$message.error("驳回时，备注不能为空");
            return false;
        }
        this.$confirm("确定后不可撤销，是否继续？").then(function () {
            var params = {
                refund_order_ids: _this.refund_order_ids,
                remark: _this.formData.remark
            };
            console.log('------print params:', params);
            _this.service.cancel(params).then(function (res) {
                if (res.data.success) {
                    if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        return;
                    }
                    else {
                        _this.$message.success(res.data.msg || "操作成功");
                    }
                    _this.close();
                    _this.$emit("check:ok", res.data, params);
                }
                else {
                    _this.$message.error(res.data.msg || "操作失败");
                }
            }, function (err) {
                _this.$message.error(err.message || "操作失败");
            });
        }, function (err) { });
    };
    CancelDialog = __decorate([
        Component
    ], CancelDialog);
    return CancelDialog;
}(VueDialog));
export default CancelDialog;
